import React, { useContext, useRef } from 'react';
import { connect } from 'react-redux';
import styles from './__styles__/index.scss?modules';
import { getDynAppHeroContent } from 'page_modules/business-vac/redux';
import { FontType, Typography } from '@americanexpress/aqx-components';
import {
  DynamicAppModalContext,
  ModalButtonRefContext
} from 'src/universal/components/DynamicApp/redux';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

const DynamicAppVacHero = ({ heroContent }) => {
  const { header, subHeader, text, learnMoreLink, imageUrl } = heroContent;
  const setIsDynamicModalOpen = useContext(DynamicAppModalContext);
  const thisButtonRef = useRef(null);
  const { setButtonRef } = useContext(ModalButtonRefContext);
  const learnMoreButton = (
    <button
      ref={thisButtonRef}
      onClick={() => {
        setButtonRef(thisButtonRef);
        setIsDynamicModalOpen();
        sendDTMClickEvent(learnMoreLink.dtm);
      }}
      title={learnMoreLink.text}
      className={styles.learnMoreButton}
    >
      {learnMoreLink.text}
    </button>
  );
  return (
    <div className={styles.dynamicAppVacHero}>
      <div className={styles.mobilePicture}>
        <img src={imageUrl} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          <Typography
            Component="h1"
            $family={FontType.HelveticaRegular}
            $size={'16px'}
            $lineHeight={'24px'}
          >
            {header}
          </Typography>
          <Typography Component="h2">{subHeader}</Typography>
          <Typography>
            {learnMoreButton}
            <Sanitizer safelySetInnerHTML={text} />
          </Typography>
        </div>
        <div className={styles.desktopPicture}>
          <img src={imageUrl} alt="" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return { heroContent: getDynAppHeroContent(state) };
};

export default connect(mapStateToProps)(DynamicAppVacHero);
